import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';

@Injectable()
export class AdminAuthGuard  {
  constructor(
    private router: Router,
    private appInfoService: AppInfoService
  ) { }

  /**
   * Can activate the route only if the user is admin
   */
  canActivate() {
    if (this.appInfoService.isAdminTypeUser()) {
      return true;
    } else {
      this.router.navigate(['/403', true]);
      return false;
    }
  }
}
